import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';

export interface BuddySettings {
    name: string;
    iconUrl: string;
    endpoint: string;
    useAuth?: boolean;
}

@Injectable({ providedIn: 'root' })
export class BuddyConfigService {
    buddyConfig: BuddySettings = {
        name: 'Buddy',
        iconUrl: 'assets/imgs/buddy.svg',
        endpoint: environment.CHATBOT_BACKEND,
        useAuth: true,
    };
}
